module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_5010.d447300b.png";